import * as React from 'react';
import { CianNewbuildingChatButton, CianNewbuildingChatButtonContext } from '@cian/newbuilding-chat-component';
import { TButtonSize } from '@cian/ui-kit/button/types';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import { useDispatch, useSelector } from 'react-redux';

import { useChatButtonContextValue } from './hooks';
import { getPlaceType } from './utils';
import { setBuilderChatButtonClicked } from '../../actions/builderChat';
import { useBuilderChat } from '../../hooks/builderChat';
import { getBuilderChatEnabled } from '../../selectors/builderChat';
import { IBuilder } from '../../types/newbuilding/builder';
import { ISeller } from '../../types/newbuilding/seller';
import { ChatOnboardingContainer } from '../ChatOnboardingContainer';
import { trackContactListOpen } from './tracking';
import { getGaLabel, getNewbuildingId } from '../../selectors/newbuilding';

interface IBuilderChatButtonContainerProps {
  isHeaderButton?: boolean;
  buttonSize?: TButtonSize;
  forcedContacts?: {
    builders: IBuilder[];
    sellers: ISeller[];
  };
}

export const BuilderChatButtonContainer: React.FC<IBuilderChatButtonContainerProps> = ({
  isHeaderButton = false,
  buttonSize = 'M',
  forcedContacts,
}) => {
  const isChatEnabled = useSelector(getBuilderChatEnabled);
  const chatButtonContextValue = useChatButtonContextValue(forcedContacts);
  const placeType = getPlaceType(isHeaderButton, Boolean(forcedContacts));
  const newbuildingId = useSelector(getNewbuildingId);
  const gaLabel = useSelector(getGaLabel);

  const dispatch = useDispatch();

  const handleButtonClick = React.useCallback(() => {
    dispatch(setBuilderChatButtonClicked());
  }, [dispatch]);

  const handleContactListModalOpen = React.useCallback(() => {
    trackContactListOpen({ newbuildingId, gaLabel, placeType });
  }, [newbuildingId, gaLabel, placeType]);

  const onSellersInfoClick = React.useCallback(() => {}, []);

  const { openChat } = useBuilderChat(placeType);

  if (!isChatEnabled) {
    return null;
  }

  const messageButton = (
    <CianNewbuildingChatButtonContext.Provider value={chatButtonContextValue}>
      <CianNewbuildingChatButton
        beforeIcon={<IconCommunicationMessage16 color="icon-main-default" />}
        size={buttonSize}
        theme={isHeaderButton ? 'fill_secondary' : 'fill_white_primary'}
        type="button"
        onClick={handleButtonClick}
        onContactListModalOpen={handleContactListModalOpen}
        onSellersInfoClick={onSellersInfoClick}
        onChatOpen={openChat}
        fullWidth
      >
        Написать
      </CianNewbuildingChatButton>
    </CianNewbuildingChatButtonContext.Provider>
  );

  if (isHeaderButton) {
    return messageButton;
  }

  return <ChatOnboardingContainer type="builder">{messageButton}</ChatOnboardingContainer>;
};
